// extracted by mini-css-extract-plugin
module.exports =  {"background":"a10a3f92e9--background--S5Ks2","background_border":"a10a3f92e9--background_border--WsOlb","title":"a10a3f92e9--title--UGJIS"};